// Include all CSS for Vite to find Tailwind
import '../Styles/style.css';

import { documentReady, preloadTranslations } from './Utils';

// Components
import { registerAccordions } from './Components/accordion';
import { registerCards } from './Components/card';
import { registerLanguagePicker } from './Components/languagePicker';
import { registerCopyImageLinks } from './Components/imageBank';
import { registerPlyr } from './Components/plyr';
import { registerSiteHeader } from './Components/siteHeader';
import { registerSocialShare } from './Components/socialShare';
import { registerCenteredSlider } from './Components/centerSlider';
import { registerPlyrLightBox } from './Components/plyrLightbox';
import { registerReadMore } from './Components/readMore';
import { registerReveal } from './Components/reveal';
import { registerSnackbarOnSubmit } from './Components/snackbar';
import { shareLink } from './Components/shareLink';

// Blocks
import { registerContactFormBlock } from './Blocks/contactForm';
import { registerLocationsBlock } from './Blocks/locations';

// Wait until document has loaded to load the scripts
documentReady(() => {
    preloadTranslations();

    registerReveal();
    registerAccordions();
    registerCards();
    registerLanguagePicker();
    registerPlyr();
    registerSiteHeader();
    registerSocialShare();
    registerCenteredSlider();
    registerPlyrLightBox();
    registerReadMore();
    registerSnackbarOnSubmit();
    registerCopyImageLinks();
    shareLink();

    // Block
    registerContactFormBlock();
    registerLocationsBlock();
});
